/**
 * SoluQR Business — rutas exclusivas del plan Business.
 */
import { businessRouteElements } from '@/soluqr/modules/business/pages';

/** @type {Array<{ segment: string, element: import('react').ReactElement }>} */
export const BUSINESS_DASHBOARD_ROUTE_ELEMENTS = [...businessRouteElements];
